<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="3" md="4" style="position:relative; top: -60px">
                <v-card>
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-currency-usd</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Mi balance</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h3">${{ balance.balance }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-4">
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-receipt</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Total de pagos pendientes</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h3">${{ pendingTotal }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-4">
                    <v-list class="pb-0" two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-credit-card</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Datos bancarios</strong></v-list-item-title>
                                <v-list-item-subtitle>Información para realizar pagos.</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-card-actions>
                        <v-btn text :color="color" @click="info_dialog = !info_dialog" block>MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>

                <v-card class="mt-4">
                    <v-btn color="success" @click="proofs_dialog = !proofs_dialog" block><strong>SUBIR COMPROBANTES DE PAGO</strong></v-btn>
                </v-card>
            </v-col>

            <v-col lg="9" md="8" style="position:relative; top: -60px">
               <v-card>
                   <v-card-text v-if="Object.keys(payments).length > 0">
                       <template v-for="(payment, index) in payments">
                            <v-card v-if="payment.quantity < 0" outlined shaped :key="index" class="mb-2">
                                <v-card-title>
                                    <v-chip class="mr-2" small :color="payment.verified == 1 ? 'success' : 'error'">{{ payment.verified == 1 ? 'Pago correcto' : 'Pendiente' }}</v-chip>
                                    {{ payment.date }}
                                    <v-spacer></v-spacer>
                                    <!-- <v-tooltip left v-if="payment.verified == 1">
                                        <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-bind="attrs" icon v-on="on" color="primary" style="text-transform: lowercase">
                                                    <v-icon>mdi-printer</v-icon>
                                                </v-btn>
                                        </template>
                                        <span>Descargar recibo</span>
                                    </v-tooltip> -->
                                </v-card-title>
                                <v-card-subtitle v-if="payment.verified == 1">ID de transacción {{ payment.proof ? payment.proof.folio+'-'+payment.id : payment.id }}</v-card-subtitle>
                                <v-card-text>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Descripción</th>
                                                    <th class="text-right">Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{{ payment.description }}</td>
                                                    <td class="text-right">MXN{{ Math.abs(payment.quantity) }}{{ payment.quantity %1 === 0 ? '.00' : '' }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-divider></v-divider>
                                    <v-simple-table flat>
                                        <template v-slot:default>
                                            <tbody>
                                                <tr>
                                                    <td class="text-right"><strong>Impuestos</strong></td>
                                                    <td class="text-right">MXN0.00</td>
                                                </tr>
                                                <tr>
                                                    <td class="text-right"><strong>Importe cobrado</strong></td>
                                                    <td class="text-right" v-if="payment.verified == 1">MXN{{ Math.abs(payment.quantity) }}{{ payment.quantity % 1 === 0 ? '.00' : '' }}</td>
                                                    <td class="text-right" v-else>MXN0.00</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                       </template>
                    </v-card-text>
                    <template v-else>
                        <v-card-text>
                            <p class="text-center mb-0">Sin pagos registrados</p>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn block color="#008dd4" dark href="/my-courses/select-course">Seleccionar curso</v-btn>
                        </v-card-actions>
                    </template>
               </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="info_dialog" width="600">
            <v-card>
                <v-card-title>Datos bancarios</v-card-title>
                <v-card-text class="pa-5">
                    <h3 class=" mb-5">Información necesaría para realizar pagos a la institución. Una vez realizado el pago, deberá subir una fotografía de su comprobante. Cuando el pago sea verificado, se realizarán los pagos pendientes y el restante será sumado a su balance.</h3>
                    <v-simple-table flat>
                        <template v-slot:default>
                            <!-- Datos hardcodeados, tabla de cuentas -->
                            <tbody>
                                <tr>
                                    <td>CLABE</td>
                                    <td><strong>012 180 00469235582 8</strong></td>
                                </tr>
                                <tr>
                                    <td>Número de tarjeta</td>
                                    <td><strong>4152 3138 7681 3309</strong></td>
                                </tr>
                                <tr>
                                    <td>Banco</td>
                                    <td><strong>BBVA Bancomer</strong></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="mx-auto" block @click="info_dialog = false" text><strong>Aceptar</strong></v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <proofs :dialog="proofs_dialog" :proofs="proofs" :store_url="store_proof_url"></proofs>
    </v-container>
</template>
<script>

import proofs from './proofs'

export default {
    props:['_balance','_payments','_proofs'],
    components:{
        proofs
    },
    data: () => ({
        data_url:'/payments',
        store_proof_url:'/payments/proof/store',
        color:'#000',
        info_dialog:false,
        proofs_dialog:false,
        transfer_dialog:false,
        balance:"",
        payments:"",
        proofs:""
    }),

    created(){
        this.balance  = Object.assign({}, this._balance)
        this.payments = Object.assign({}, this._payments)
        this.proofs   = Object.assign({}, this._proofs)
    },

    methods:{
        getData:function(){
            axios.get(this.data_url).then(response => {
                this.balance  = response.data.balance
                this.payments = response.data.payments
                this.proofs   = response.data.proofs
            }).catch(error => {})
        }
    },

    computed:{
        pendingTotal: function(){
            let total = 0
            this._payments.forEach(payment => {
                if(payment.quantity < 0 && payment.verified == 0) total += Math.abs(payment.quantity)
            });

            return total
        }
    }
}
</script>
